/**
 * @generated SignedSource<<c4f1457cf08eb1cd2ca989d9d4f4b73b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type QuickView_itemSearch$data = {
  readonly " $fragmentSpreads": FragmentRefs<"QuickViewCategory_itemSearch">;
  readonly " $fragmentType": "QuickView_itemSearch";
};
export type QuickView_itemSearch$key = {
  readonly " $data"?: QuickView_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"QuickView_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "QuickView_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "QuickViewCategory_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "56ae1d9f67fc239ecf01ec52c6a00a7d";

export default node;
